<script setup lang="ts">
import { TheTooltip } from '@wastedondestiny/destiny-library'

defineOptions({ inheritAttrs: false })

const props = withDefaults(defineProps<{
  name: string,
  description?: string,
  image: string,
  unlocked: boolean,
  progress?: string,
  innerClasses?: string | Record<string, boolean>
}>(), {
  progress: '',
  innerClasses: ''
})

const fullUrl = `/badges/${props.image}`
</script>

<template>
  <TheTooltip>
    <template #content>
      <h2 class="text-xl font-semibold">{{ name }}</h2>
      <p>{{ description }}</p>
      <small v-if="progress">{{ progress }}</small>
    </template>
    <div v-bind="$attrs" class="h-5 w-5 mt-1 grid place-items-center rounded-md" :class="{ 'opacity-100': unlocked, 'opacity-50': !unlocked }">
      <img :src="fullUrl" :alt="name" class="h-4 w-4 object-contain" v-bind:class="innerClasses" />
    </div>
  </TheTooltip>
</template>
